import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { intervalToDuration } from 'date-fns';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isDateValid({ date }: { date: Date }) {
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  return true;
}

const avatarColors = [
  'primary-500',
  'secondary-500',
  'gray-500',
  'green-500',
  'yellow-500',
  'red-500',
  'additional-turquoise',
  'additional-greenSea',
  'additional-emerald',
  'additional-nephritis',
  'additional-peterRiver',
  'additional-belizeHole',
  'additional-amethyst',
  'additional-wisteria',
  'additional-wetAsphalt',
  'additional-midnightBlue',
  'additional-sunFlower',
  'additional-orange',
  'additional-carrot',
  'additional-pumpkin',
  'additional-alizarin',
  'additional-pomegranate',
];

export const getRandomColor = (userId: string): string => {
  if (!userId) return avatarColors[0] ?? '';
  const int = userId
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return avatarColors[int % avatarColors.length] ?? '';
};

export const floatingLabelStyles =
  'absolute -top-[0.6rem] h-3 left-4 opacity-1 px-0.5 text-xs text-gray-400 group-focus:text-primary group-data-[invalid=true]:text-red bg-inherit transition-all group-data-[placeholder-shown]:top-2 group-data-[placeholder-shown]:opacity-0 group-data-[placeholder-shown]:-z-10';

export const formatMsTime = (milliseconds: number) => {
  const duration = intervalToDuration({
    start: 0,
    end: Math.round(milliseconds),
  });
  const hours = duration.hours;
  const minutes = duration.minutes?.toString().padStart(2, '0') ?? '00';
  const seconds = duration.seconds?.toString().padStart(2, '0') ?? '00';

  if (hours && hours > 0) {
    return `${hours}:${minutes}:${seconds}`;
  }
  return `${minutes}:${seconds}`;
};

export const buildIdFromStepName = (stepName: string) => {
  const specialCharacters = /[^a-zA-Z0-9-]/g;
  const sanitizedStepName = stepName.replace(specialCharacters, '-');
  return `_${sanitizedStepName.toLowerCase()}`;
};
